//请自行添加语言资源
const circuit = {
  companyCode: '机构编码',
  companyName: '机构名称',
  shipperCode: '货主编码',
  shipperName: '货主名称',
  carrierNo: '承运商编号',
  carrierName: '承运商名称',
  sendProvince: '发货省份',
  sendCity: '发货城市',
  sendArea: '发货区/县',
  receiveProvince: '收货省份',
  receiveCity: '收货城市',
  receiveArea: '收货区/县',
  transTypeName: '运输方式',
  businessTypeName: '业务类型',
  otd: '要求到达天数',
  rtd: '要求回单天数',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '更新时间',
  updater: '更新者',

  company: '所属机构',
  carrier: '承运商',
  origin: '发货方',
  dest: '收货方',
};
export default circuit



// WEBPACK FOOTER //
// ./src/page/mdm/route/lang/circuit.zh.js